import React, { useState, useEffect, useContext, useRef } from 'react';
import LoadingSpinnerImage from "../Shared/LoadingSpinnerImage.js";
import DatePicker from 'react-datepicker';


let debounceTimer = null;

const AddItemPopup = ({ globalContext }) => {

    const [isAddingBasicUDI, setIsAddingBasicUDI] = useState(false);

    const [issuingEntity, setIssuingEntity] = useState("");
    const [basicUDIDICode, setBasicUDIDICode] = useState("");
    const [legalManufacturerSRN, setLegalManufacturerSRN] = useState("");
    const [applicableRegulation, setApplicableRegulation] = useState("");
    const [deviceSystemProcedureType, setDeviceSystemProcedureType] = useState("");
    const [isKit, setIsKit] = useState("false");
    const [specialDeviceType, setSpecialDeviceType] = useState("");
    const [authorisedRepresentative, setAuthorisedRepresentative] = useState("");
    const [riskClass, setRiskClass] = useState("");
    const [tissuesCellsAnimal, setTissuesCellsAnimal] = useState("false");
    const [tissuesCellsMicrobial, setTissuesCellsMicrobial] = useState("false");
    const [tissuesCellsHuman, setTissuesCellsHuman] = useState("false");
    const [deviceModel, setDeviceModel] = useState("");
    const [deviceName, setDeviceName] = useState("");
    const [activeDevice, setActiveDevice] = useState("false");
    const [deviceIntendedAdministerRemoveMedicinalProduct, setDeviceIntendedAdministerRemoveMedicinalProduct] = useState("false");
    const [implantable, setImplantable] = useState("false");
    const [measuringFunction, setMeasuringFunction] = useState("false");
    const [reusableSurgicalInstruments, setReusableSurgicalInstruments] = useState("false");
    const [companionDiagnostic, setCompanionDiagnostic] = useState("false");
    const [nearPatientTesting, setNearPatientTesting] = useState("false");
    const [patientSelfTesting, setPatientSelfTesting] = useState("false");
    const [presenceSubstanceMedicinalProductHumanBloodPlasma, setPresenceSubstanceMedicinalProductHumanBloodPlasma] = useState("false");
    const [presenceSubstanceMedicinalProduct, setPresenceSubstanceMedicinalProduct] = useState("false");
    const [reagent, setReagent] = useState("false");
    const [professionalTesting, setProfessionalTesting] = useState("false");
    const [instrument, setInstrument] = useState("false");
    const [isDeviceSutureStapleDental, setIsDeviceSutureStapleDental] = useState("");

    const [errorAddingBasicUdi, setErrorAddingBasicUdi] = useState(null);

    const [errorIssuingEntity, setErrorIssuingEntity] = useState(false);
    const [errorBasicUDIDICode, setErrorBasicUDIDICode] = useState(false);
    const [errorLegalManufacturerSRN, setErrorLegalManufacturerSRN] = useState(false);
    const [errorApplicableRegulation, setErrorApplicableRegulation] = useState(false);
    const [errorDeviceSystemProcedureType, setErrorDeviceSystemProcedureType] = useState(false);
    const [errorIsKit, setErrorIsKit] = useState(false);
    const [errorSpecialDeviceType, setErrorSpecialDeviceType] = useState(false);
    const [errorAuthorisedRepresentative, setErrorAuthorisedRepresentative] = useState(false);
    const [errorRiskClass, setErrorRiskClass] = useState(false);
    const [errorTissuesCellsAnimal, setErrorTissuesCellsAnimal] = useState(false);
    const [errorTissuesCellsMicrobial, setErrorTissuesCellsMicrobial] = useState(false);
    const [errorTissuesCellsHuman, setErrorTissuesCellsHuman] = useState(false);
    const [errorDeviceModel, setErrorDeviceModel] = useState(false);
    const [errorDeviceName, setErrorDeviceName] = useState(false);
    const [errorActiveDevice, setErrorActiveDevice] = useState(false);
    const [errorDeviceIntendedAdministerRemoveMedicinalProduct, setErrorDeviceIntendedAdministerRemoveMedicinalProduct] = useState(false);
    const [errorImplantable, setErrorImplantable] = useState(false);
    const [errorMeasuringFunction, setErrorMeasuringFunction] = useState(false);
    const [errorReusableSurgicalInstruments, setErrorReusableSurgicalInstruments] = useState(false);
    const [errorCompanionDiagnostic, setErrorCompanionDiagnostic] = useState(false);
    const [errorNearPatientTesting, setErrorNearPatientTesting] = useState(false);
    const [errorPatientSelfTesting, setErrorPatientSelfTesting] = useState(false);
    const [errorPresenceSubstanceMedicinalProductHumanBloodPlasma, setErrorPresenceSubstanceMedicinalProductHumanBloodPlasma] = useState(false);
    const [errorPresenceSubstanceMedicinalProduct, setErrorPresenceSubstanceMedicinalProduct] = useState(false);
    const [errorReagent, setErrorReagent] = useState(false);
    const [errorProfessionalTesting, setErrorProfessionalTesting] = useState(false);
    const [errorInstrument, setErrorInstrument] = useState(false);
    const [errorIsDeviceSutureStapleDental, setErrorIsDeviceSutureStapleDental] = useState(false);


    const AppContext = globalContext;



    const addBasicUDI = () => {
    
        let isValid = true;

        setErrorAddingBasicUdi(null);
        setErrorIssuingEntity(false);
        setErrorBasicUDIDICode(false);
        setErrorLegalManufacturerSRN(false);
        setErrorApplicableRegulation(false);
        setErrorDeviceSystemProcedureType(false);
        setErrorIsKit(false);
        setErrorSpecialDeviceType(false);
        setErrorAuthorisedRepresentative(false);
        setErrorRiskClass(false);
        setErrorTissuesCellsAnimal(false);
        setErrorTissuesCellsMicrobial(false);
        setErrorTissuesCellsHuman(false);
        setErrorDeviceModel(false);
        setErrorDeviceName(false);
        setErrorActiveDevice(false);
        setErrorDeviceIntendedAdministerRemoveMedicinalProduct(false);
        setErrorImplantable(false);
        setErrorMeasuringFunction(false);
        setErrorReusableSurgicalInstruments(false);
        setErrorCompanionDiagnostic(false);
        setErrorNearPatientTesting(false);
        setErrorPatientSelfTesting(false);
        setErrorPresenceSubstanceMedicinalProductHumanBloodPlasma(false);
        setErrorPresenceSubstanceMedicinalProduct(false);
        setErrorReagent(false);
        setErrorProfessionalTesting(false);
        setErrorInstrument(false);
        setErrorIsDeviceSutureStapleDental(false);


        if(issuingEntity == "") {
            setErrorIssuingEntity(true);
            isValid = false;
        }
        if(basicUDIDICode == "") {
            setErrorBasicUDIDICode(true);
            isValid = false;
        }
        if(legalManufacturerSRN == "") {
            setErrorLegalManufacturerSRN(true);
            isValid = false;
        }
        if(applicableRegulation == "") {
            setErrorApplicableRegulation(true);
            isValid = false;
        }
        if(deviceSystemProcedureType == "") {
            setErrorDeviceSystemProcedureType(true);
            isValid = false;
        }
        if(isKit == "") {
            setErrorIsKit(true);
            isValid = false;
        }
        if(riskClass == "") {
            setErrorRiskClass(true);
            isValid = false;
        }
        if(tissuesCellsAnimal == "") {
            setErrorTissuesCellsAnimal(true);
            isValid = false;
        }
        if(tissuesCellsMicrobial == "") {
            setErrorTissuesCellsMicrobial(true);
            isValid = false;
        }
        if(tissuesCellsHuman == "") {
            setErrorTissuesCellsHuman(true);
            isValid = false;
        }
        if(activeDevice == "") {
            setErrorActiveDevice(true);
            isValid = false;
        }
        if(deviceIntendedAdministerRemoveMedicinalProduct == "") {
            setErrorDeviceIntendedAdministerRemoveMedicinalProduct(true);
            isValid = false;
        }
        if(implantable == "") {
            setErrorImplantable(true);
            isValid = false;
        }
        if(measuringFunction == "") {
            setErrorMeasuringFunction(true);
            isValid = false;
        }
        if(reusableSurgicalInstruments == "") {
            setErrorReusableSurgicalInstruments(true);
            isValid = false;
        }
        if(companionDiagnostic == "") {
            setErrorCompanionDiagnostic(true);
            isValid = false;
        }
        if(nearPatientTesting == "") {
            setErrorNearPatientTesting(true);
            isValid = false;
        }
        if(patientSelfTesting == "") {
            setErrorPatientSelfTesting(true);
            isValid = false;
        }
        if(presenceSubstanceMedicinalProductHumanBloodPlasma == "") {
            setErrorPresenceSubstanceMedicinalProductHumanBloodPlasma(true);
            isValid = false;
        }
        if(presenceSubstanceMedicinalProduct == "") {
            setErrorPresenceSubstanceMedicinalProduct(true);
            isValid = false;
        }
        if(reagent == "") {
            setErrorReagent(true);
            isValid = false;
        }
        if(professionalTesting == "") {
            setErrorProfessionalTesting(true);
            isValid = false;
        }
        if(instrument == "") {
            setErrorInstrument(true);
            isValid = false;
        }

        if (!(deviceModel || "").trim() && !(deviceName || "").trim()) {
            setErrorDeviceModel(true);
            setErrorDeviceName(true);
            isValid = false;
        }

        if (!isValid) { 
            setErrorAddingBasicUdi("Some values are not correct, review the errors and try again")
            return;

        }

        let newItem = {
            Id: 0,
            IssuingEntityBasicUDI_DI: issuingEntity,
            BasicUDI_DI_Code: basicUDIDICode,
            LegalManufacturerSRN: legalManufacturerSRN,
            ApplicableRegulation: applicableRegulation,
            IsItSystemADeviceInItself: deviceSystemProcedureType,
            IsItAKit: isKit,
            SpecialDeviceType: specialDeviceType,
            AuthorisedRepresentative: authorisedRepresentative,
            RiskClass: riskClass,
            PresenceOfAnimalTissuesOrCells: tissuesCellsAnimal,
            PresenceOfCellsOrSubstancesOfMicrobialOrigin: tissuesCellsMicrobial,
            PresenceOfHumanTissuesOrCells: tissuesCellsHuman,
            DeviceModel: deviceModel,
            DeviceName: deviceName,
            ActiveDevice: activeDevice,
            DeviceIntendedToAdministerAndOrRemoveMedicinalOroduct: deviceIntendedAdministerRemoveMedicinalProduct,
            Implantable: implantable,
            MeasuringFunction: measuringFunction,
            ReusableSurgicalInstruments: reusableSurgicalInstruments,
            CompanionDiagnostic: companionDiagnostic,
            NearPatientTesting: nearPatientTesting,
            PatientSelfTesting: patientSelfTesting,
            PresenceOfSubstanceyMayBeConsideredAMedicinalProductDerivedFromHumanBloodOrPlasma: presenceSubstanceMedicinalProductHumanBloodPlasma,
            PresenceOfSubstanceyMayBeConsideredAMedicinalProduct: presenceSubstanceMedicinalProduct,
            Reagent: reagent,
            ProfessionalTesting: professionalTesting,
            Instrument: instrument,
            IsItDeviceSutureStapleDentalFilling: isDeviceSutureStapleDental,

        };
        




        let dataUrl = AppContext.dataUrl;

        let requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(newItem)
        };


        setIsAddingBasicUDI(true);

        fetch(dataUrl, requestOptions)
            .then(async (response) => {
                if (!response.ok) {
                    let message = await response.text();

                    if (response.status == 400)
                        throw new Error(message);

                    throw new Error("Unexpected error, refresh and try again");

                }
                return response.json();
            })
            .then((item) => {

                let result = [item, ...AppContext.data];

                AppContext.setData(result);

                AppContext.showAddItemPopup(false);

            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
                setErrorAddingBasicUdi(error.message);
            })
            .finally(() => {
                setIsAddingBasicUDI(false);
            });


    }








    return (
        <div className="add-task-popup">
            <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ width: "50%" }}>
                    <h3>Add {AppContext.singleItemTitle}</h3>
                </div>
                <div style={{ width: "50%", textAlign: "right" }}>
                    <button
                        className="close-button"
                        onClick={() => AppContext.showAddItemPopup(false)}
                    >
                        <i className="fas fa-times"></i>
                    </button>
                </div>
            </div>



            
            


            
            
            
            
            
            
            
            
            
            
            
            
            
            
            
            
            
            
            


            Issuing Entity Basic UDI-DI *
            <br />
            <select className={`form-field-text add-task-field-name ${errorIssuingEntity ? " form-field-error" : null}`}
                value={issuingEntity} onChange={(e) => setIssuingEntity(e.target.value)}>
                <option value=""></option>
                <option value="GS1">GS1</option>
                <option value="HIBCC">HIBCC</option>
                <option value="ICCBBA">ICCBBA</option>
                <option value="IFA">IFA</option>
                <option value="EUDAMED">EUDAMED</option>
            </select>
            {errorIssuingEntity ? <><br/><span className="form-field-error-message">This field is necessary</span></> : null}
            <br />
            <br />

            Basic UDI-DI code *
            <br />
              <input className={`form-field-text add-task-field-name ${errorBasicUDIDICode ? " form-field-error" : null}`}
                value={basicUDIDICode}
                onChange={(e) => setBasicUDIDICode(e.target.value)}
                style={{ width: "100%" }} type="text" placeholder="Basic UDI-DI code *" />
            {errorBasicUDIDICode ? <><br/><span className="form-field-error-message">This field is necessary</span></> : null}
            <br />
            <br />

            Legal Manufacturer SRN *
            <br />
            <input className={`form-field-text add-task-field-name ${errorLegalManufacturerSRN ? " form-field-error" : null}`}
                value={legalManufacturerSRN}
                onChange={(e) => setLegalManufacturerSRN(e.target.value)}
                style={{ width: "100%" }} type="text" placeholder="Legal Manufacturer SRN *" />
            {errorLegalManufacturerSRN ? <><br/><span className="form-field-error-message">This field is necessary</span></> : null}
            <br />
            <br />

            Applicable regulation *
            <br />
            <select className={`form-field-text add-task-field-name ${errorApplicableRegulation ? " form-field-error" : null}`}
                value={applicableRegulation} onChange={(e) => setApplicableRegulation(e.target.value)}>
                <option value=""></option>
                <option value="MDR">REGULATION (EU) 2017/745 on medical devices</option>
                <option value="IVDR">REGULATION (EU) 2017/746 on in vitro diagnostic medical devices</option>
                <option value="MDD">Council Directive 93/42/EEC on Medical devices</option>
                <option value="AIMDD">Council Directive 90/385/EEC - Approximation of the laws of the Member States relating to active implantable medical devices</option>
                <option value="IVDD">Directive 98/79/EC on in vitro diagnostic medical devices</option>
                <option value="NONE">None</option>
                <option value="UNKNOWN">Unknown</option>
            </select>
            {errorApplicableRegulation ? <><br/><span className="form-field-error-message">This field is necessary</span></> : null}
            <br />
            <br />

            Is it a System which is a Device in itself, Procedure pack which is a Device in itself *
            <br />
            <select className={`form-field-text add-task-field-name ${errorDeviceSystemProcedureType ? " form-field-error" : null}`}
                value={deviceSystemProcedureType} onChange={(e) => setDeviceSystemProcedureType(e.target.value)}>
                <option value=""></option>
                <option value="DEVICE">DEVICE</option>
                <option value="PROCEDURE_PACK">PROCEDURE_PACK</option>
                <option value="SYSTEM">SYSTEM</option>
            </select>
            {errorDeviceSystemProcedureType ? <><br/><span className="form-field-error-message">This field is necessary</span></> : null}
            <br />
            <br />

            Is it a Kit *
            <br />
            <select className={`form-field-text add-task-field-name ${errorIsKit ? " form-field-error" : null}`}
                value={isKit} onChange={(e) => setIsKit(e.target.value)}>
                <option value="false">No</option>
				<option value="true">Yes</option>
            </select>
            {errorIsKit ? <><br/><span className="form-field-error-message">This field is necessary</span></> : null}
            <br />
            <br />

            Special Device Type
            <br />
            <select className={`form-field-text add-task-field-name ${errorSpecialDeviceType ? " form-field-error" : null}`}
                value={specialDeviceType} onChange={(e) => setSpecialDeviceType(e.target.value)}>
                <option value=""></option>
                <option value="IVDR_SOFTWARE">Software - IVDR_SOFTWARE</option>
                <option value="IVDD_SOFTWARE">Software - IVDD_SOFTWARE</option>
                <option value="MDR_SOFTWARE">Software - MDR_SOFTWARE</option>
                <option value="MDD_SOFTWARE">Software - MDD_SOFTWARE</option>
                <option value="AIMDD_SOFTWARE">Software - AIMDD_SOFTWARE</option>
                <option value="MDR_STANDARD_SOFT_CONTACT_LENSES">Standard soft contact lenses - MDR_STANDARD_SOFT_CONTACT_LENSES</option>
                <option value="MDD_STANDARD_SOFT_CONTACT_LENSES">Standard soft contact lenses - MDD_STANDARD_SOFT_CONTACT_LENSES</option>
                <option value="MDR_RIGID_GAS_PERMEABLE">Rigid Gas Permeable (RGP) Contact Lenses - MDR_RIGID_GAS_PERMEABLE</option>
                <option value="MDD_RIGID_GAS_PERMEABLE">Rigid Gas Permeable (RGP) Contact Lenses - MDD_RIGID_GAS_PERMEABLE</option>
                <option value="MDR_MADE_TO_ORDER">Made to order soft contact lenses - MDR_MADE_TO_ORDER</option>
                <option value="MDD_MADE_TO_ORDER">Made to order soft contact lenses - MDD_MADE_TO_ORDER</option>
                <option value="MDR_MADE_TO_ORDER_RIGID_GAS_PERMEABLE">Made to order Rigid Gas Permeable (RGP) contact lenses - MDR_MADE_TO_ORDER_RIGID_GAS_PERMEABLE</option>
                <option value="MDR_SPECTACLES_FRAMES">Spectacle frames - MDR_SPECTACLES_FRAMES</option>
                <option value="MDD_SPECTACLES_FRAMES">Spectacle frames - MDD_SPECTACLES_FRAMES</option>
                <option value="MDR_SPECTACLES_LENSES">Spectacle lenses - MDR_SPECTACLES_LENSES</option>
                <option value="MDD_SPECTACLES_LENSES">Spectacle lenses - MDD_SPECTACLES_LENSES</option>
                <option value="MDR_READY_MADE_SPECTACLES">Ready-made reading spectacles - MDR_READY_MADE_SPECTACLES</option>
                <option value="MDD_READY_MADE_SPECTACLES">Ready-made reading spectacles - MDD_READY_MADE_SPECTACLES</option>
                <option value="MDR_ORTHOPEDIC">Orthopaedic - MDR_ORTHOPEDIC</option>
                <option value="MDD_ORTHOPEDIC">Orthopaedic - MDD_ORTHOPEDIC</option>
                <option value="AIMDD_ORTHOPEDIC">Orthopaedic - AIMDD_ORTHOPEDIC</option>
            </select>
            {errorSpecialDeviceType ? <><br/><span className="form-field-error-message">This field is necessary</span></> : null}
            <br />
            <br />

            Authorised Representative SRN
            <br />
              <input className={`form-field-text add-task-field-name ${errorAuthorisedRepresentative ? " form-field-error" : null}`}
                value={authorisedRepresentative}
                onChange={(e) => setAuthorisedRepresentative(e.target.value)}
                style={{ width: "100%" }} type="text" placeholder="Authorised Representative SRN" />
            {errorAuthorisedRepresentative ? <><br/><span className="form-field-error-message">This field is necessary</span></> : null}
            <br />
            <br />

            Risk Class *
            <br />
            <select className={`form-field-text add-task-field-name ${errorRiskClass ? " form-field-error" : null}`}
                value={riskClass} onChange={(e) => setRiskClass(e.target.value)}>
                <option value=""></option>
                <option value="aimdd">aimdd</option>
                <option value="class-a">class-a</option>
                <option value="class-b">class-b</option>
                <option value="class-c">class-c</option>
                <option value="class-d">class-d</option>
                <option value="class-i">class-i</option>
                <option value="ivd-annex-ii-list-a">ivd-annex-ii-list-a</option>
                <option value="class-iia">class-iia</option>
                <option value="ivd-annex-ii-list-b">ivd-annex-ii-list-b</option>
                <option value="class-iib">class-iib</option>
                <option value="ivd-devices-self-testing">ivd-devices-self-testing</option>
                <option value="class-iii">class-iii</option>
                <option value="ivd-general">ivd-general</option>
            </select>
            {errorRiskClass ? <><br/><span className="form-field-error-message">This field is necessary</span></> : null}
            <br />
            <br />

            Tissues and cells - Presence of animal tissues or Cells, or their derivates *
            <br />
            <select className={`form-field-text add-task-field-name ${errorTissuesCellsAnimal ? " form-field-error" : null}`}
                value={tissuesCellsAnimal} onChange={(e) => setTissuesCellsAnimal(e.target.value)}>
                <option value="false">No</option>
				<option value="true">Yes</option>
            </select>
            {errorTissuesCellsAnimal ? <><br/><span className="form-field-error-message">This field is necessary</span></> : null}
            <br />
            <br />

            Tissues and cells - Presence of cells or substances of microbial origin *
            <br />
            <select className={`form-field-text add-task-field-name ${errorTissuesCellsMicrobial ? " form-field-error" : null}`}
                value={tissuesCellsMicrobial} onChange={(e) => setTissuesCellsMicrobial(e.target.value)}>
                <option value="false">No</option>
				<option value="true">Yes</option>
            </select>
            {errorTissuesCellsMicrobial ? <><br/><span className="form-field-error-message">This field is necessary</span></> : null}
            <br />
            <br />

            Tissues and cells - presence of human tissues or cells, or their derivates *
            <br />
            <select className={`form-field-text add-task-field-name ${errorTissuesCellsHuman ? " form-field-error" : null}`}
                value={tissuesCellsHuman} onChange={(e) => setTissuesCellsHuman(e.target.value)}>
                <option value="false">No</option>
				<option value="true">Yes</option>
            </select>
            {errorTissuesCellsHuman ? <><br/><span className="form-field-error-message">This field is necessary</span></> : null}
            <br />
            <br />

            Device Model
            <br />
              <input className={`form-field-text add-task-field-name ${errorDeviceModel ? " form-field-error" : null}`}
                value={deviceModel}
                onChange={(e) => setDeviceModel(e.target.value)}
                style={{ width: "100%" }} type="text" placeholder="Device Model" />
            {errorDeviceModel ? <><br/><span className="form-field-error-message">Device Model or Device Name is required</span></> : null}
            <br />
            <br />

            Device Name
            <br />
              <input className={`form-field-text add-task-field-name ${errorDeviceName ? " form-field-error" : null}`}
                value={deviceName}
                onChange={(e) => setDeviceName(e.target.value)}
                style={{ width: "100%" }} type="text" placeholder="Device Name" />
            {errorDeviceName ? <><br/><span className="form-field-error-message">Device Model or Device Name is required</span></> : null}
            <br />
            <br />

            Active Device *
            <br />
            <select className={`form-field-text add-task-field-name ${errorActiveDevice ? " form-field-error" : null}`}
                value={activeDevice} onChange={(e) => setActiveDevice(e.target.value)}>
                <option value="false">No</option>
				<option value="true">Yes</option>
            </select>
            {errorActiveDevice ? <><br/><span className="form-field-error-message">This field is necessary</span></> : null}
            <br />
            <br />

            Device Intended to administer and/or Remove medicinal product *
            <br />
            <select className={`form-field-text add-task-field-name ${errorDeviceIntendedAdministerRemoveMedicinalProduct ? " form-field-error" : null}`}
                value={deviceIntendedAdministerRemoveMedicinalProduct} onChange={(e) => setDeviceIntendedAdministerRemoveMedicinalProduct(e.target.value)}>
                <option value="false">No</option>
				<option value="true">Yes</option>
            </select>
            {errorDeviceIntendedAdministerRemoveMedicinalProduct ? <><br/><span className="form-field-error-message">This field is necessary</span></> : null}
            <br />
            <br />

            Implantable *
            <br />
            <select className={`form-field-text add-task-field-name ${errorImplantable ? " form-field-error" : null}`}
                value={implantable} onChange={(e) => setImplantable(e.target.value)}>
                <option value="false">No</option>
				<option value="true">Yes</option>
            </select>
            {errorImplantable ? <><br/><span className="form-field-error-message">This field is necessary</span></> : null}
            <br />
            <br />

            Measuring Function *
            <br />
            <select className={`form-field-text add-task-field-name ${errorMeasuringFunction ? " form-field-error" : null}`}
                value={measuringFunction} onChange={(e) => setMeasuringFunction(e.target.value)}>
                <option value="false">No</option>
				<option value="true">Yes</option>
            </select>
            {errorMeasuringFunction ? <><br/><span className="form-field-error-message">This field is necessary</span></> : null}
            <br />
            <br />

            Reusable Surgical Instruments *
            <br />
            <select className={`form-field-text add-task-field-name ${errorReusableSurgicalInstruments ? " form-field-error" : null}`}
                value={reusableSurgicalInstruments} onChange={(e) => setReusableSurgicalInstruments(e.target.value)}>
                <option value="false">No</option>
				<option value="true">Yes</option>
            </select>
            {errorReusableSurgicalInstruments ? <><br/><span className="form-field-error-message">This field is necessary</span></> : null}
            <br />
            <br />

            Companion Diagnostic *
            <br />
            <select className={`form-field-text add-task-field-name ${errorCompanionDiagnostic ? " form-field-error" : null}`}
                value={companionDiagnostic} onChange={(e) => setCompanionDiagnostic(e.target.value)}>
                <option value="false">No</option>
				<option value="true">Yes</option>
            </select>
            {errorCompanionDiagnostic ? <><br/><span className="form-field-error-message">This field is necessary</span></> : null}
            <br />
            <br />

            Near Patient Testing *
            <br />
            <select className={`form-field-text add-task-field-name ${errorNearPatientTesting ? " form-field-error" : null}`}
                value={nearPatientTesting} onChange={(e) => setNearPatientTesting(e.target.value)}>
                <option value="false">No</option>
				<option value="true">Yes</option>
            </select>
            {errorNearPatientTesting ? <><br/><span className="form-field-error-message">This field is necessary</span></> : null}
            <br />
            <br />

            Patient Self Testing *
            <br />
            <select className={`form-field-text add-task-field-name ${errorPatientSelfTesting ? " form-field-error" : null}`}
                value={patientSelfTesting} onChange={(e) => setPatientSelfTesting(e.target.value)}>
                <option value="false">No</option>
				<option value="true">Yes</option>
            </select>
            {errorPatientSelfTesting ? <><br/><span className="form-field-error-message">This field is necessary</span></> : null}
            <br />
            <br />

            Presence of a substance which , if used separately, may be considered to be a medicinal product derived from human blood or plasma *
            <br />
            <select className={`form-field-text add-task-field-name ${errorPresenceSubstanceMedicinalProductHumanBloodPlasma ? " form-field-error" : null}`}
                value={presenceSubstanceMedicinalProductHumanBloodPlasma} onChange={(e) => setPresenceSubstanceMedicinalProductHumanBloodPlasma(e.target.value)}>
                <option value="false">No</option>
				<option value="true">Yes</option>
            </select>
            {errorPresenceSubstanceMedicinalProductHumanBloodPlasma ? <><br/><span className="form-field-error-message">This field is necessary</span></> : null}
            <br />
            <br />

            Presence of substance which, if used separately, may be considered to be a medicinal product *
            <br />
            <select className={`form-field-text add-task-field-name ${errorPresenceSubstanceMedicinalProduct ? " form-field-error" : null}`}
                value={presenceSubstanceMedicinalProduct} onChange={(e) => setPresenceSubstanceMedicinalProduct(e.target.value)}>
                <option value="false">No</option>
				<option value="true">Yes</option>
            </select>
            {errorPresenceSubstanceMedicinalProduct ? <><br/><span className="form-field-error-message">This field is necessary</span></> : null}
            <br />
            <br />

            Reagent *
            <br />
            <select className={`form-field-text add-task-field-name ${errorReagent ? " form-field-error" : null}`}
                value={reagent} onChange={(e) => setReagent(e.target.value)}>
                <option value="false">No</option>
				<option value="true">Yes</option>
            </select>
            {errorReagent ? <><br/><span className="form-field-error-message">This field is necessary</span></> : null}
            <br />
            <br />

            Professional Testing *
            <br />
            <select className={`form-field-text add-task-field-name ${errorProfessionalTesting ? " form-field-error" : null}`}
                value={professionalTesting} onChange={(e) => setProfessionalTesting(e.target.value)}>
                <option value="false">No</option>
				<option value="true">Yes</option>
            </select>
            {errorProfessionalTesting ? <><br/><span className="form-field-error-message">This field is necessary</span></> : null}
            <br />
            <br />

            Instrument *
            <br />
            <select className={`form-field-text add-task-field-name ${errorInstrument ? " form-field-error" : null}`}
                value={instrument} onChange={(e) => setInstrument(e.target.value)}>
                <option value="false">No</option>
				<option value="true">Yes</option>
            </select>
            {errorInstrument ? <><br/><span className="form-field-error-message">This field is necessary</span></> : null}
            <br />
            <br />  

            Is it Device a suture, staple, dental filling, dental brace (...)?
            <br />
            <select className={`form-field-text add-task-field-name ${errorIsDeviceSutureStapleDental ? " form-field-error" : null}`}
                value={isDeviceSutureStapleDental} onChange={(e) => setIsDeviceSutureStapleDental(e.target.value)}>
                <option value=""></option>
                <option value="false">No</option>
				<option value="true">Yes</option>
            </select>
            {errorIsDeviceSutureStapleDental ? <><br/><span className="form-field-error-message">This field is necessary</span></> : null}
            <br />
            <br />


            {/* BUTTONS */}

            <br />
            <div className="action-button-bar">

                <div className="action-button-bar-left">
                    <button
                        className="action-button cancel-button"
                        onClick={() => AppContext.showAddItemPopup(false)}
                    >
                        Close
                    </button>
                </div>

                <div className="action-button-bar-center">

                    {errorAddingBasicUdi ? <div style={{ color: "#ff5400" }}>Error: {errorAddingBasicUdi}</div> : null}

                </div>

                <div className="action-button-bar-right">
                    {isAddingBasicUDI ? (
                        <LoadingSpinnerImage />
                    ) : (
                        <button
                            className="action-button save-button"
                                onClick={addBasicUDI}
                        >
                            Add Basic UDI
                        </button>
                    )}
                </div>

            </div>



            <br />

        </div>
    );
};








export default AddItemPopup;